module.exports = __webpack_public_path__ + "img/case-icon-7.b91aa4bb.png";